export function getVehicleAfterUpdatePreRegist(data) {
    return {
        type: "GET_VEHICLE_AFTER_UPDATE_PRE_REGIST",
        preRegistVehicleData: data
    }
}